import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  SPORTS = 'Sports',
  FOOTBALL = 'Football',
  TENNIS = 'Tennis',
  BASEBALL = 'Baseball',
  GOLF = 'Golf',
  SOCCER = 'Soccer',
  BASKETBALL = 'Basketball',
  OLYMPICS = 'Olympics',
  HOCKEY = 'Hockey',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['sports'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/football'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/tennis'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/baseball'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/golf'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/soccer'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/basketball'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/olympics'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['sports/hockey'] } }
    ]
  }
};

const FOOTBALL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/football'] } }]
  }
};

const TENNIS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/tennis'] } }]
  }
};

const BASEBALL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/baseball'] } }]
  }
};

const GOLF = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/golf'] } }]
  }
};

const SOCCER = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/soccer'] } }]
  }
};

const BASKETBALL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/basketball'] } }]
  }
};

const OLYMPICS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/olympics'] } }]
  }
};

const HOCKEY = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['sports/hockey'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'sports',
            'sports/football',
            'sports/tennis',
            'sports/baseball',
            'sports/golf',
            'sports/soccer',
            'sports/basketball',
            'sports/olympics',
            'sports/hockey'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'sports' } }, { prefix: { key: 'DJEThing', value: 'sports/' } }],
    not: []
  }
};

export {
  MAIN,
  SECTION_ENUM,
  FOOTBALL,
  TENNIS,
  BASEBALL,
  GOLF,
  SOCCER,
  BASKETBALL,
  OLYMPICS,
  HOCKEY,
  RELATED_OPINION,
  VIDEO
};
